<template>
  <div
    class="private-feedback-collapsed-button"
    @click="openExpandedFeedbackPanel"
  >
    <span class="arrow-icon">
      <aha-icon
        name="arrow-no-tail"
        viewBox="0 0 8 14"
        width="12"
        height="21"
      />
    </span>
    <div class="text capitalize">
      {{ $t('Get feedback') }}
    </div>
  </div>
</template>
<script>
import FeedbackPanelMixin from '@/mixins/presentation/FeedbackPanelMixin'

export default {
  mixins: [FeedbackPanelMixin],
  props: {
    presentation: {
      type: Object,
      default: () => {},
    },
    slideActive: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    openExpandedFeedbackPanel() {
      this.$emit('open')
      this.trackFeedbackPanelEvent('Private feedback > Expand panel')
    },
  },
}

</script>
<style lang="scss" scoped>
.private-feedback-collapsed-button {
  @apply bg-secondary-60 text-base-20 absolute top-1/2 cursor-pointer flex items-center justify-center;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  transform: translateY(-120px) rotate(-90deg);
  transform-origin: right;
  right: 19px;
  z-index: 148;
  font-weight: bold;
  padding: 8px 20px;
  font-size: 0.9rem;
  & .arrow-icon {
    transform: rotate(-90deg);
    color: #fff;
    margin-right: 8px;
  }
  &:hover {
    color: #fff;
  }

}
</style>
